/**
 * Controla el diálogo de rechazar tarea.
 */
EditIncidenciaDialogCtrl.$inject = ['$log', '$scope'];
export default function EditIncidenciaDialogCtrl($log, $scope) {

    if ($scope.model.soloEmplazamiento) {
        $scope.emplazamientoActivo = Sigo.config['mostrar_emplazamiento'];
        $scope.origenActivo = false;
        $scope.expedienteActivo = false;
        if ($scope.model.emplazamiento.length == 0) {
            $scope.model.emplazamiento = $scope.model.direccion;
        }
    } else {
        $scope.emplazamientoActivo = false;
        $scope.origenActivo = Sigo.config['origen_incidencia'];
        $scope.expedienteActivo = Sigo.config['expediente_incidencia'];
    }

    $scope.hayOrigenes = issetAndNotEmpty($scope.model.origenes) && $scope.model.origenes.length > 0;
    if (!issetAndNotEmpty($scope.model.origen_id) && $scope.origenActivo && $scope.hayOrigenes)
        $scope.model.origen_id = $scope.model.origenes[Object.keys($scope.model.origenes)[0]].id;


    // console.log($scope.model.fecha_expediente);
    // console.log(moment($scope.model.fecha_expediente, "DD/MM/YYYY HH:mm").isValid());
    if (!moment($scope.model.fecha_expediente, "DD/MM/YYYY HH:mm").isValid())
        $scope.model.fecha_expediente = "";
}